export default __webpack_public_path__ + "static/media/img09.084b56b9.jpg";